








import {Component, Prop, Vue} from 'vue-property-decorator';

@Component({
    components: {},
})
export default class LoadingDialog extends Vue {
    public open = false;
    @Prop({default: 'Please stand by'})
    public message!: string;
    @Prop({default: true})
    public persistent!: boolean;
    @Prop({default: 300})
    public width!: number;
}
